export default class PuzzleMove{

    constructor(type) {
        this.type = type;
    }
}

PuzzleMove.EMBARK = "EMBARK";
PuzzleMove.DISEMBARK = "DISEMBARK";
PuzzleMove.CROSS = "CROSS";

PuzzleMove.ALL = [PuzzleMove.EMBARK, PuzzleMove.DISEMBARK, PuzzleMove.CROSS];